<cosmos-auth-layout
  [title]="'recovery.resetTitle' | translate"
  [subtitle]="'recovery.resetSubtitle' | translate"
>

  <div class="reset-form">

    <div class="form-fields">

      <p-floatlabel variant="on" class="w-full">
        <p-password
          inputId="reset-password"
          [(ngModel)]="password"
          [feedback]="true"
          [toggleMask]="true"
          fluid
        />
        <label for="reset-password">{{ 'fields.password' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on" class="w-full mt-2">
        <p-password
          inputId="reset-confirm"
          [(ngModel)]="confirmPassword"
          [feedback]="false"
          [toggleMask]="true"
          fluid
        />
        <label for="reset-confirm">{{ 'fields.confirmPassword' | translate }}</label>
      </p-floatlabel>

      @if (passwordMismatch) {
        <p-message severity="error" styleClass="w-full mt-2">
          {{ 'recovery.password-not-match' | translate }}
        </p-message>
      }

    </div>

    @if (error()) {
      <p-message severity="error" styleClass="w-full mt-2">
        {{ 'recovery.error' | translate }}
      </p-message>
    }
    @if (success()) {
      <p-message severity="success" styleClass="w-full mt-2">
        {{ 'recovery.password-changed' | translate }}
      </p-message>
    }

    <div class="form-actions mt-2">
      @if (!success()) {
        <button
          pButton
          type="button"
          severity="primary"
          [label]="'button.recover' | translate"
          [loading]="loading()"
          [disabled]="!password || passwordMismatch"
          (click)="onClick()"
          class="w-full"
        ></button>
      }
      @if (success()) {
        <button
          pButton
          type="button"
          severity="primary"
          [label]="'button.login' | translate"
          routerLink="/login"
          class="w-full"
        ></button>
      }
    </div>

  </div>

</cosmos-auth-layout>
